import { FunctionComponent, useMemo } from 'react'
import DOMPurify from 'dompurify'
import classNames from 'classnames'
import { Text as TextProps } from './Text.types'
import { getTextStyleClassName, getTextTag } from './text.utils'
import './Text.scss'

export const Text: FunctionComponent<TextProps> = ({
  attributes,
  className
}) => {
  const { value, style, color } = attributes
  const textClassName = getTextStyleClassName(style)
  const TextTag = getTextTag(style)
  const sanitizedValue = useMemo(() => DOMPurify.sanitize(value), [value])

  return (
    <TextTag
      className={classNames('core-ux-text', textClassName, className)}
      style={{ color }}
      data-testid="text"
      dangerouslySetInnerHTML={{ __html: sanitizedValue }}
    />
  )
}
